import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.function.name";
import { connect } from 'react-redux';
import { similarVenues } from 'redux/saga/entities/bound';
import { RecommendedVenues } from './RecommendedVenues';

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var recommendations = similarVenues.data(state, ownProps.venueId) || [];
  var similar = recommendations.slice(0, 2);
  return {
    recommendations: similar.map(function (recommendation) {
      return {
        alias: recommendation.alias,
        imageUrl: recommendation.images.default,
        venue: recommendation.name
      };
    }),
    venue: ownProps.venue,
    venueId: ownProps.venueId
  };
};

export var RecommendedVenuesContainer = connect(mapStateToProps)(RecommendedVenues);